import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";

const countByCategory = (slug: string) => comics.filter((comic) => comic.categories.includes(slug)).length;

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">分类快捷入口</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按题材快速找到你喜欢的漫画类型</p>
        </div>
        <Link
          to="/category/rexue"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600 sm:flex"
        >
          进入分类页
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-primary-300 hover:bg-primary-50/60"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-xl`} />
            </span>
            <span className="flex items-center justify-between">
              <span className="font-heading text-sm font-bold text-foreground-950">{category.name}</span>
              <span className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
                {countByCategory(category.slug)}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}